export {wrapRootElement} from './src'
